import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import DashboardLayout from './components/layout/DashboardLayout'
import HomePage from './pages/HomePage'
import LotteryResultsPage from './pages/LotteryResultsPage'
import LotteryResultDetailPage from './pages/LotteryResultDetailPage'
import AnalysisHomePage from './pages/AnalysisHomePage'
import HotColdAnalysisPage from './pages/analysis/HotColdAnalysisPage'
import OddEvenAnalysisPage from './pages/analysis/OddEvenAnalysisPage'
import NumberSumAnalysisPage from './pages/analysis/NumberSumAnalysisPage'
import ReappearanceAnalysisPage from './pages/analysis/ReappearanceAnalysisPage'
import LuckyNumberPage from './pages/analysis/LuckyNumberPage'
import ConsecutiveNumbersPage from './pages/analysis/ConsecutiveNumbersPage'
import SubscriptionPlansPage from './pages/SubscriptionPlansPageNew'
import FAQPage from './pages/FAQPage'
import LoginPage from './pages/auth/LoginPage'
import RegisterPage from './pages/auth/RegisterPage'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import DashboardPage from './pages/dashboard/DashboardPage'
import ProfilePage from './pages/dashboard/ProfilePage'
import MyNumbersPage from './pages/dashboard/MyNumbersPage'
import SubscriptionPage from './pages/dashboard/SubscriptionPage'
import AuthCallback from './components/auth/AuthCallback'
import PrivateRoute from './components/auth/PrivateRoute'
import AnnouncementModal from './components/AnnouncementModal'
import ScrollToTop from './components/ScrollToTop'
import TermsPage from './pages/legal/TermsPage'
import PrivacyPage from './pages/legal/PrivacyPage'
import TermsConsentPage from './pages/TermsConsentPage'
import { ThemeProvider } from '@workspace/public-utils'

function App() {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <AnnouncementModal />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="results" element={<LotteryResultsPage />} />
          <Route path="results/:roundNumber" element={<LotteryResultDetailPage />} />
          <Route path="analysis" element={<AnalysisHomePage />} />
          <Route path="analysis/hot-cold" element={<HotColdAnalysisPage />} />
          <Route path="analysis/odd-even" element={<OddEvenAnalysisPage />} />
          <Route path="analysis/number-sum" element={<NumberSumAnalysisPage />} />
          <Route path="analysis/reappearance" element={<ReappearanceAnalysisPage />} />
          <Route path="analysis/lucky-number" element={<LuckyNumberPage />} />
          <Route path="analysis/consecutive-numbers" element={<ConsecutiveNumbersPage />} />
          <Route path="plans" element={<SubscriptionPlansPage />} />
          <Route path="faq" element={<FAQPage />} />
        </Route>
        
        {/* Auth Routes */}
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/register" element={<RegisterPage />} />
        <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        
        {/* Public Terms Consent Page - accessible via SMS link */}
        <Route path="/plans/:consentPath" element={<TermsConsentPage />} />
        
        {/* Protected Dashboard Routes */}
        <Route path="/dashboard" element={<PrivateRoute />}>
          <Route path="" element={<Layout />}>
            <Route index element={<DashboardLayout><DashboardPage /></DashboardLayout>} />
            <Route path="profile" element={<DashboardLayout><ProfilePage /></DashboardLayout>} />
            <Route path="numbers" element={<DashboardLayout><MyNumbersPage /></DashboardLayout>} />
            <Route path="subscription" element={<DashboardLayout><SubscriptionPage /></DashboardLayout>} />
          </Route>
        </Route>
      </Routes>
    </ThemeProvider>
  )
}

export default App